import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { until } from 'lit/directives/until.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { parseJwt } from '../../common/helpers.js';
import { subscribe } from '../../common/reactiveX/rxElementDecorators.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import '../../common/loadingSpinner.js';
let FulfillmentPhrases = class FulfillmentPhrases extends RxElement {
    constructor() {
        super(...arguments);
        this.parsedToken = {};
        this.coachId = '';
        this.account = '';
        this.editRow = '';
        this.filters = [];
        this.filterMapping = { All: [] };
        this.copyPhrase = async (e) => {
            const id = e.target.getAttribute('data-id');
            const typeid = e.target.getAttribute('data-typeid');
            const title = e.target.getAttribute('data-title');
            const phrase = e.target.getAttribute('data-phrase');
            const phrasetype = e.target.getAttribute('data-phrasetype');
            const copyHtml = `<p data-type="phrase" data-id="${id}" data-typeid="${typeid}" data-title="${title}" data-phrase="${phrase}" data-phrasetype="${phrasetype}">${phrase === null || phrase === void 0 ? void 0 : phrase.replace('#account#', this.account.toLowerCase())}</p>`;
            const blob = Promise.resolve(new Blob([copyHtml], { type: 'text/html' }));
            // eslint-disable-next-line no-undef
            const item = new ClipboardItem({ "text/html": blob });
            await navigator.clipboard.write([item]);
            e.preventDefault();
        };
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        this.parsedToken = parseJwt(this.blueUser.accessToken ? this.blueUser.accessToken : '');
        this.coachId = this.parsedToken.oid;
        until(this.fetchPhrases(), 'Loading...');
    }
    async fetchPhrases() {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        const results = await fetch(new Request(`${process.env.API_URL}/blue/openphrases/coach/${this.coachId}/account/${this.account}`, { headers }));
        if (results.ok || results.status === 200) {
            const json = await results.json();
            this.allPhrases = json;
            this.phrases = json;
            this.content = json;
            this.buildFilter();
        }
        return null;
    }
    async savePhrase() {
        const phrase = this._phrase.value;
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        const data = {
            title: 'test',
            phrase,
        };
        const requestUrl = `${process.env.API_URL}/blue/coachphrase`;
        const results = await fetch(new Request(requestUrl, {
            method: 'POST',
            headers,
            body: JSON.stringify(data),
        }));
        if (results.ok || results.status === 200) {
            this._phraseContainer.style.display = 'none';
            this._createPhrase.style.display = 'block';
            this.fetchPhrases();
        }
        return results;
    }
    // eslint-disable-next-line class-methods-use-this
    _dragResource(e) {
        const id = e.path[0].getAttribute('data-id');
        const typeid = e.path[0].getAttribute('data-typeid');
        const title = e.path[0].getAttribute('data-title');
        const phrase = e.path[0].getAttribute('data-phrase');
        const phrasetype = e.path[0].getAttribute('data-phrasetype');
        e.dataTransfer.setData('text/html', `<p data-type="phrase" data-id="${id}" data-typeid="${typeid}" data-title="${title}" data-phrase="${phrase}" data-phrasetype="${phrasetype}">${e.path[0].innerText}</p>`);
    }
    searchPhrases() {
        const search = this._phraseSearch.value.toLowerCase();
        const filter = this._filter.value.toLowerCase();
        if (filter === 'all') {
            this.content = this.allPhrases;
        }
        else {
            this.content = this.phrases;
        }
        const obj = this.content.filter(o => o.phrase.toLowerCase().includes(search));
        this.content = obj;
    }
    buildFilter() {
        this.filterMapping.All = this.allPhrases;
        this.phrases.forEach(p => {
            const id = p.type.toString().charAt(0).toUpperCase() + p.type.slice(1);
            this.filters.push(id);
            const keyExists = Object.keys(this.filterMapping).includes(id);
            if (keyExists) {
                this.filterMapping[id].push(p);
            }
            else {
                this.filterMapping[id] = [p];
            }
        });
        this.filters = [...new Set(this.filters)];
        this.filters.sort((a, b) => a.localeCompare(b));
        this.filters.unshift('All');
    }
    filterPhrases() {
        const filter = this._filter.value;
        if (filter === 'All') {
            this.phrases = this.allPhrases;
        }
        else {
            this.phrases = this.filterMapping[filter];
        }
        this.content = this.phrases;
    }
    createPhrase() {
        this._createPhrase.style.display = 'none';
        this._phraseContainer.style.display = 'block';
    }
    cancelPhrase() {
        this._phraseContainer.style.display = 'none';
        this._createPhrase.style.display = 'block';
    }
    cancelEditedPhrase(e) {
        e.preventDefault();
        this.editRow = null;
    }
    async saveEditedPhrase(e) {
        e.preventDefault();
        const phraseId = e.target.getAttribute('data-id');
        const phrase = this._editedPhrase.value;
        const phraseObj = this.phrases.find(p => p.id === phraseId);
        if (phrase !== '' && phraseObj) {
            phraseObj.phrase = phrase;
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            const results = await fetch(new Request(`${process.env.API_URL}/blue/updatephrase`, {
                method: 'POST',
                headers,
                body: JSON.stringify(phraseObj),
            }));
            if (results.ok || results.status === 200) {
                this.fetchPhrases();
                this.editRow = null;
            }
        }
    }
    async deletePhrase(e) {
        e.preventDefault();
        const phraseId = e.target.getAttribute('data-id');
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        const results = await fetch(new Request(`${process.env.API_URL}/blue/deletephrase/phrase/${phraseId}`, {
            method: 'POST',
            headers,
        }));
        if (results.ok || results.status === 200) {
            this.fetchPhrases();
            this.editRow = null;
        }
        return null;
    }
    editPhrase(e) {
        e.preventDefault();
        const phraseId = e.target.getAttribute('data-id');
        this.editRow = phraseId;
    }
    render() {
        var _a;
        if (!((_a = this.allPhrases) === null || _a === void 0 ? void 0 : _a.length) && (!this.content || !this.content.length)) {
            return html `<loading-spinner loadingText="Loading phrases..."></loading-spinner>`;
        }
        return html `<div class="search__bar">
        <svg class="search__icon">
          <use
            href="/static/icons.svg#search"
            xlink:href="/static/icons.svg#search"
          />
        </svg>
        <input type="text" id="phrase__search" @keyup="${this.searchPhrases}" />
        ${this.filters.length
            ? html `<select id="phrase__filter" @change="${this.filterPhrases}">
              ${this.filters.map(f => html `<option value="${f}">${unsafeHTML(f)}</option>`)};
            </select>`
            : ''}
      </div>
      <div class="tab__content">
        <h4>Custom Phrases</h4>
              <table id="phrase__table">
                ${this.content.map(phrase => html `<tr
                    id="${phrase.id}-row"
                    class="phrase__entry"
                  >
                    ${this.editRow && this.editRow === phrase.id
            ? html `<td class="phrase__editorCell" colspan="4">
                            <div id="phrase__editor" class="phrase__editor">
                              <div
                                id="phrase__editorContainer"
                                class="phrase__editorContainer"
                              >
                                <h4 class="save__heading">Edit</h4>
                                <div class="save__input">
                                  <textarea
                                    id="phrase__editInput"
                                    class="phrase__editInput"
                                    rows="4"
                                    cols="50"
                                    .innerText="${phrase.phrase}"
                                  ></textarea>
                                </div>
                                <div class="save__buttons">
                                  <mwc-button
                                    raised
                                    data-id="${phrase.id}"
                                    label="Delete"
                                    style="margin:10px 10px 0 0;--mdc-theme-primary:red;"
                                    @click="${this.deletePhrase}"
                                  ></mwc-button>
                                  <mwc-button
                                    raised
                                    data-id="${phrase.id}"
                                    label="Cancel"
                                    style="margin:10px 10px 0 0;--mdc-theme-primary:#707070;"
                                    @click="${this.cancelEditedPhrase}"
                                  ></mwc-button>
                                  <mwc-button
                                    raised
                                    data-id="${phrase.id}"
                                    label="Save"
                                    style="margin-top:10px;--mdc-theme-primary:#2C7FAD;"
                                    @click="${this.saveEditedPhrase}"
                                  ></mwc-button>
                                </div>
                              </div>
                            </div>
                          </td>`
            : html ` <td class="phrase__favorite">
                            <svg class="phrase__heart">
                              <use
                                href="/static/icons.svg#heart"
                                xlink:href="/static/icons.svg#heart"
                              />
                            </svg>
                          </td>
                          <td class="phrase__cell">
                            <p
                              data-type="phrase"
                              data-title="${phrase.title}"
                              data-phrase="${phrase.phrase}"
                              data-id="${phrase.id}"
                              data-typeid="${phrase.typeId}"
                              data-phrasetype="${phrase.type}"
                              draggable="true"
                              @dragstart="${this._dragResource}"
                              class="draggable phrase"
                            >
                              ${unsafeHTML(phrase.phrase.replace('#account#', this.account.toLowerCase()))}
                            </p>
                          </td>
                          <td class="phrase__copy">
                            <span
                              class="copy__phrase"
                              @click="${this.copyPhrase}"
                              @keyup="${this.copyPhrase}"
                              data-id="${phrase.id}"
                              data-typeid="${phrase.typeId}"
                              data-phrase="${phrase.phrase}"
                              data-phrasetype="${phrase.type}"
                              data-title="${phrase.title}"
                              >Copy</span
                            >
                          </td>
                          <td class="phrase__edit">
                            ${phrase.type === 'coach'
                ? html `<span
                                  class="edit__phrase"
                                  @click="${this.editPhrase}"
                                  @keyup="${this.editPhrase}"
                                  data-id="${phrase.id}"
                                  data-phrase="${phrase.phrase}"
                                  >Edit</span
                                >`
                : ''}
                          </td>`}
                  </tr>`)}
              </table>
              <div id="phrase__save" class="phrase__save">
                <div id="phrase__container" class="phrase__container">
                  <h4 class="save__heading">Type your phrase</h4>
                  <div class="save__input">
                    <textarea
                      id="phrase__input"
                      class="phrase__input"
                      rows="4"
                      cols="50"
                    ></textarea>
                  </div>
                  <div class="save__buttons">
                    <mwc-button
                      raised
                      label="Cancel"
                      style="margin:10px 10px 0 0;--mdc-theme-primary:#707070;"
                      @click="${this.cancelPhrase}"
                    ></mwc-button>
                    <mwc-button
                      raised
                      label="Save"
                      style="margin-top:10px;--mdc-theme-primary:#2C7FAD;"
                      @click="${this.savePhrase}"
                    ></mwc-button>
                  </div>
                </div>
                <div id="create__phrase">
                  <a class="create__link" @click="${this.createPhrase}">
                    <svg class="create__add">
                      <use
                        href="/static/icons.svg#plus"
                        xlink:href="/static/icons.svg#plus"
                      />
                    </svg>
                    <p>Create a New Phrase</p>
                  </a>
                </div>
              </div>
      </div>`;
    }
};
FulfillmentPhrases.styles = css `
    :host {
      width: 100%;
    }
    h4 {
      color: #073853;
      margin-left: 8px;
    }
    .save__heading {
      margin: 10px 0;
    }
    #phrase__filter {
      width: 50%;
      height: 34px;
      margin: 8px 20px;
      border-radius: 8px;
      border: 1px solid #d3d3d3;
      padding-left: 10px;
    }
    #phrase__search {
      width: 400px;
      height: 30px;
      margin: 8px 0 8px 20px;
      border-radius: 8px;
      border: 1px solid #d3d3d3;
      padding-left: 35px;
    }
    #phrase__search:focus,
    #phrase__filter:focus {
      outline: none;
      border-color: #007cab !important;
      border-width: 2px;
    }
    .search__bar {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: #f7f7fa;
      height: 50px;
      border-top: 1px solid #efefef;
      border-bottom: 1px solid #efefef;
    }
    .tab__content {
      padding: 0 20px 20px;
    }
    .phrase__entry {
      width: 100%;
      margin: 0;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      font-size: 14px;
    }
    .phrase {
      display: inline-block;
      text-decoration: none;
      color: #000000;
      margin: 8px 0 8px 8px;
      font-size: 14px;
      width: 100%;
      height: 100%;
    }
    .phrase__entry:nth-child(even) {
      background: #f7f7fa !important;
    }
    .copy__phrase,
    .edit__phrase {
      font-weight: 500;
      color: #007cab;
      cursor: pointer;
    }
    .phrase__input,
    .phrase__editInput {
      width: 100%;
      min-height: 100px;
      border-radius: 10px;
      border: 2px solid #007cab;
      resize: vertical;
      padding: 10px;
      box-sizing: border-box;
      font-size: 15px;
    }
    .phrase__heart {
      color: #d0d0d0;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    .phrase__container {
      display: none;
      background: #f3f9fb;
      padding: 10px;
      margin-top: 10px;
    }
    .phrase__editorContainer {
      background: #f3f9fb;
      padding: 10px;
    }
    .search__icon {
      height: 25px;
      width: 25px;
      vertical-align: middle;
      position: relative;
      margin-right: -57px;
      margin-left: 32px;
    }
    .save__buttons {
      display: flex;
      justify-content: flex-end;
    }
    #create__phrase {
      margin: 12px 0 12px 6px;
    }
    .phrase__favorite {
      width: 24px;
      text-align: center;
    }
    .phrase__copy,
    .phrase__edit {
      width: 40px;
      text-align: center;
    }
    .create__add {
      color: #fff;
      width: 14px;
      height: 14px;
      background-color: #007cab;
      border-radius: 50%;
      margin: 0 8px 0 0;
    }
    .create__link {
      font-weight: 500;
      color: #007cab;
      font-size: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .editor__buffer {
      width: 0px;
      background: #f3f9fb;
    }
  `;
__decorate([
    subscribe(),
    state()
], FulfillmentPhrases.prototype, "blueUser", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "parsedToken", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "allPhrases", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "phrases", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "content", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "coachId", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "account", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "editRow", void 0);
__decorate([
    query('#phrase__search')
], FulfillmentPhrases.prototype, "_phraseSearch", void 0);
__decorate([
    query('#phrase__filter')
], FulfillmentPhrases.prototype, "_filter", void 0);
__decorate([
    query('#phrase__input')
], FulfillmentPhrases.prototype, "_phrase", void 0);
__decorate([
    query('#phrase__container')
], FulfillmentPhrases.prototype, "_phraseContainer", void 0);
__decorate([
    query('#create__phrase')
], FulfillmentPhrases.prototype, "_createPhrase", void 0);
__decorate([
    query('#phrase__table')
], FulfillmentPhrases.prototype, "_phraseTable", void 0);
__decorate([
    query('#phrase__editInput')
], FulfillmentPhrases.prototype, "_editedPhrase", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "filters", void 0);
__decorate([
    property()
], FulfillmentPhrases.prototype, "filterMapping", void 0);
FulfillmentPhrases = __decorate([
    customElement('fulfillment-phrases')
], FulfillmentPhrases);
export { FulfillmentPhrases };
//# sourceMappingURL=phrases.js.map